<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let containerType: string;
  export let disabled: boolean = false;
  export let inventoryId: number;
  export let quantity: number;
  export let disableIncrement: boolean = false;

  const dispatch = createEventDispatcher();

  function emitOnChange(newQuantity: number) {
    if (newQuantity < 0) {
      newQuantity = 0;
    }

    dispatch("inputQuantityChange", {
      newQuantity,
    });
  }

  function getInputValue(event: any) {
    const parsed = Number.parseInt(event.target.value, 10);
    return Number.isNaN(parsed) ? quantity : parsed;
  }

  const limitReached = (newQuantity, currentQuantity, disableIncrement): boolean => {
    return newQuantity > currentQuantity && disableIncrement;
  };

  function handleBlur(event: FocusEvent) {
    let newCount = getInputValue(event);
    if (limitReached(newCount, quantity, disableIncrement)) {
      const input = event.target as HTMLInputElement;
      input.value = quantity.toString();
      return;
    }

    if (newCount !== quantity) {
      emitOnChange(newCount);
      quantity = newCount;
    }
  }

  function handleKeyPress(event: KeyboardEvent) {
    let newCount = getInputValue(event);
    if (event.key === "Enter" && newCount !== quantity) {
      if (limitReached(newCount, quantity, disableIncrement)) {
        const input = event.target as HTMLInputElement;
        input.value = quantity.toString();
        return;
      }

      emitOnChange(newCount);
      quantity = newCount;
    }
  }
</script>

<style>
  .cart-widget-input {
    width: 40px;
    height: 30px;
    outline: none;
  }

  .cart-widget-input:hover {
    border-color: #008fbe;
    -webkit-box-shadow: inset 0 0 2px #008fbe;
    box-shadow: inset 0 0 2px #008fbe;
  }
</style>

<input
  data-testid={`cart-widget-input-${containerType}-${inventoryId}`}
  min="0"
  max={disableIncrement ? quantity : 999}
  type="number"
  class="cart-widget-input fizz-bordered fizz-text-center"
  value={quantity}
  {disabled}
  on:keypress={handleKeyPress}
  on:blur={handleBlur}
/>
